import type { PostPublic } from "@softmax/observatory-client/types";
import type { ForumPostRecord } from "@softmax/web-ux/forum";

export function postContent({
  post,
  elevatedPrivileges,
}: {
  readonly post: PostPublic;
  readonly elevatedPrivileges: boolean;
}): ForumPostRecord["content"] {
  if (post.deleted_at || post.body === "[deleted]")
    return { format: "deleted" };

  if (post.content_format === "text" || post.content_format === "markdown") {
    if (typeof post.body !== "string")
      throw new Error("Inline forum post is missing its body");

    return { format: post.content_format, body: post.body };
  }

  if (typeof post.render_url !== "string")
    throw new Error("Rendered forum post is missing its URL");

  const prefix = elevatedPrivileges
    ? "/api/observatory/v2/admin"
    : "/api/observatory/v2";
  return {
    format: post.content_format,
    src: `${prefix}${post.render_url.replace(/^\/v2/, "")}`,
  };
}
